import getSign from '@didi/wsgsig'
import { getQuery, buildUrl, serialize, getEnvObj, transformRes } from './util'

function checkWhiteList (url, whiteList) {
  return whiteList.some(item => {
    return item === '*' || (item instanceof RegExp ? item.test(url) : url.indexOf(item) > -1)
  })
}

export default function signRequest (config, signWhiteList = [], mpx) {
  return new Promise((resolve, reject) => {
    const needSign = config.needSign === undefined
      ? checkWhiteList(config.url, signWhiteList)
      : config.needSign

    if (needSign) {
      // 去除参数自带的wsgsig
      if (config.params && config.params.hasOwnProperty('wsgsig')) {
        delete config.params.wsgsig
      }
      if (config.data && config.data.hasOwnProperty('wsgsig')) {
        delete config.data.wsgsig
      }
    }

    const paramsSerializer = config.paramsSerializer || serialize
    const bodySerializer = config.bodySerializer || paramsSerializer

    if (config.params) {
      config.url = buildUrl(config.url, config.params, paramsSerializer)
      // 这个参数保留的话，若其value是响应式数据，在Android支付宝小程序中可能有问题
      delete config.params
    }

    const contentType = config.header['content-type'] || config.header['Content-Type']
    const isUrlEncode = /application\/x-www-form-urlencoded/i.test(contentType)
    const isJSON = /application\/json/i.test(contentType)

    if ((isUrlEncode || isJSON) && typeof config.data === 'object') {
      // 序列化
      config.data = isUrlEncode ? bodySerializer(config.data) : JSON.stringify(config.data)
    }

    if (needSign) {
      const signOptions = {
        paramsString: getQuery(config.url),
        noDomainCheck: true
      }
      if ((isUrlEncode || isJSON) && config.data) {
        // 只处理json & urlencode
        signOptions.bodyString = config.data || ''
        signOptions.contentType = contentType.toLocaleLowerCase()
      }
      config.url = buildUrl(config.url, {
        wsgsig: getSign(signOptions)
      }, paramsSerializer)
    }

    const rawSuccess = config.success
    const rawFail = config.fail
    let requestTask
    let cancelMsg
    let canceled = false
    const cancelToken = config.cancelToken
    if (cancelToken) {
      cancelToken.then((msg) => {
        cancelMsg = msg
        if (requestTask?.abort) {
          requestTask.abort()
        } else {
          config.fail({})
          canceled = true
        }
      })
    }
    config.success = function (res) {
      if (canceled) {
        return
      }
      res = Object.assign({ requestConfig: config }, transformRes(res))
      typeof rawSuccess === 'function' && rawSuccess.call(this, res)
      resolve(res)
    }
    config.fail = function (res) {
      if (canceled) {
        return
      }
      res = Object.assign({ requestConfig: config }, transformRes(res))
      const err = cancelMsg !== undefined ? cancelMsg : res
      typeof rawFail === 'function' && rawFail.call(this, err)
      reject(err)
    }

    const envObj = getEnvObj()
    if (envObj && typeof envObj.request === 'function') {
      requestTask = envObj.request(config)
      return
    }

    if (__mpx_mode__ === 'ali' && typeof envObj.httpRequest === 'function') {
      requestTask = envObj.httpRequest(config)
      return
    }

    mpx = mpx || global.__mpx
    if (typeof mpx !== 'undefined' && typeof mpx.request === 'function') {
      if (config.useBridge && __mpx_mode__ === 'web') {
        import(/* webpackChunkName: "didi-unify-bridge" */ '@didi/unify-bridge').then((Bridge) => {
          const bridge = Bridge.default || Bridge
          bridge.request({
            url: config.url,
            method: config.method,
            header: config.header,
            timeout: config.timeout || 15000,
            data: config.params
          }, (res) => {
            const bridgeErrCode = res.errCode * 1
            if (bridgeErrCode >= -9999 && bridgeErrCode <= -9000) {
              const rawSuccess = config.success
              const rawFail = config.fail
              config.success = function (res) {
                rawSuccess({...res, bridgeErrCode })
              }
              config.fail = function (res) {
                rawFail({...res, bridgeErrCode })
              }
              const res = mpx.request(config)
              requestTask = res.__returned || res
              return
            }
            if (res.success) {
              config.success( { data: res.data?.data, url: config.url, type: 'bridge' })
            } else {
              config.fail( { errMsg: res.errMsg, data: res.errCode, url: config.url, type: 'bridge' })
            }
          })
        })
      } else {
        const res = mpx.request(config)
        requestTask = res.__returned || res
      }
      return
    }
    console.error('no available request adapter for current platform')
  })
}
